import { MediaContentShowcaseItem } from "onnit-ui/lib/module/MediaContentShowcase";

const ingredients: MediaContentShowcaseItem[] = [
    {
        image: `ingredients-noogandha.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Noogandha<span class="oui-sup">®</span>',
        summary:
            'A trademarked form of Ashwagandha extract, an adaptogenic herb with nootropic properties.<span class="oui-sup">†</span>',
        detail:
            'Supports mental agility, concentration, and mental processing speed while helping to manage the physiological, cognitive and psychological effects of normal stress.<span class="oui-sup">†</span>',
    },
    {
        image: `ingredients-lcitrulline.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "L-Citrulline",
        summary: "An amino acid that was first found in watermelon.",
        detail:
            'Promotes endurance performance and helps with exercise-induced muscle fatigue.<span class="oui-sup">†</span>',
    },
    {
        image: `ingredients-alphasize2.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'AlphaSize<span class="oui-sup">®</span>',
        summary: "A trademarked form of Alpha-GPC, a precursor to the neurotransmitter acetylcholine.",
        detail:
            'Supplies a source of choline, a nutrient that is important to the nervous system and necessary for healthy brain functioning.<span class="oui-sup">†</span>',
    },
    {
        image: `ingredients-betaalanine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Beta Alanine",
        summary: "An amino acid similar to creatine.",
        detail:
            'Aids exercise work capacity and supports mental focus in a fatigued state post training.<span class="oui-sup">†</span>',
    },
    {
        image: `ingredients-caffeine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Caffeine Anhydrous",
        summary: "A concentrated caffeine source.",
        detail:
            'Caffeine promotes alertness, and aids mental processing speed and sharpness. In the dosage found here, caffeine also supports exercise performance, in part by reducing your perception of effort—so training hard feels easier!<span class="oui-sup">†</span>',
    },
    {
        image: `ingredients-dynamine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Dynamine<span class="oui-sup">™</span>',
        summary: "A trademarked form of methylliberine, a methylxanthine metabolite.",
        detail:
            'Dynamine<span class="oui-sup">™</span> is gaining popularity in the sports nutrition space for its ability to complement caffeine.',
    },
];

export default ingredients;
